import { render, staticRenderFns } from "./volume.vue?vue&type=template&id=10d33f92&scoped=true"
import script from "./volume.vue?vue&type=script&lang=js"
export * from "./volume.vue?vue&type=script&lang=js"
import style0 from "./volume.vue?vue&type=style&index=0&id=10d33f92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d33f92",
  null
  
)

export default component.exports